module.exports = __webpack_public_path__ + "static/img/1-1.491a9f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/1-1.png
// module id = t332
// module chunks = 0